﻿import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IRenderPassExport } from "@models/entity-models";
import { Export } from "./export";

@Kbo(CToken.RenderPassExport)
export class RenderPassExport extends Export implements IRenderPassExport {

    constructor(kom: KbObjectManager) {
        super(kom);
    }
    
    public pass: string;
    public viewpoint: string;
    public frameCamera: boolean;
    public framePadding: number;
    public allowEmpty: boolean;
    public width: number;
    public height: number;
}
